var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Sexe","invalid-feedback":_vm.invalidFeedback}},[_c('b-form-select',{attrs:{"options":_vm.optionsSexe,"value":_vm.sexe,"required":""},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }